import { workspacesApi } from 'api'
import { WorkspaceAncestors } from 'types/workspaces/workspace'

export interface Params {
  azId: string
}

export const fetchWorkspaceWithAncestorsApi = ({ azId }: Params) =>
  workspacesApi.get<WorkspaceAncestors[]>(`/${azId}/ancestors`)
